import dayjs from 'dayjs';
// import Fingerprint2 from 'fingerprintjs2';
// import sha1 from 'sha1';
import ShortUUID from 'short-uuid';

import { MessageTypeConstants } from '../services/bot/Message';
import { STATION_ONE_LANDING } from '../utils/constants';
import { getSignupPath } from '../services/storage/LocalStorage';


export const spaceToUnderscore = (value) => (value.trim().split(' ').length > 1
  ? value.trim().split(' ').join('_')
  : value);

export const createUUID = () => {
  const uuid = ShortUUID.uuid();
  return ShortUUID().fromUUID(uuid);
};

export const getDateTimeString = (createdOn) => {
  const messageDate = dayjs(createdOn);
  const currentDate = dayjs();

  if (currentDate.endOf('day').diff(messageDate.endOf('day'), 'days') === 0) {
    return messageDate.format('HH:mm');
  }

  if (currentDate.endOf('day').diff(messageDate.endOf('day'), 'days') === 1) {
    return `Yesterday, ${messageDate.format('HH:mm')}`;
  }

  if (currentDate.year() === messageDate.year()) {
    return messageDate.format('ddd, D MMM HH:mm');
  }

  return messageDate.format('ddd, D MMM YYYY HH:mm');
};

export const computeElapsedTime = (modifiedOn) => {
  const date1 = dayjs();
  const date2 = dayjs(modifiedOn);
  if (date1.diff(date2, 'days') === 1) {
    return '1d';
  }
  if (date1.diff(date2, 'days') > 1) {
    return date2.format('DD MMM');
  }

  if (date1.diff(date2, 'hours') >= 1) {
    return `${date1.diff(date2, 'hours')}h`;
  }
  if (date1.diff(date2, 'minutes') === 0) {
    return 'just now';
  }
  return `${date1.diff(date2, 'minutes')}m`;
};

export const urlB64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

// export const getDeviceId = () => new Promise((resolve) => (
//   // eslint-disable-next-line new-cap
//   new Fingerprint2.get({ extendedJsFonts: true }, (result) => { resolve(result); })
// ));

export const getUpdatedSubscriptions = (data = [], subscription) => {
  const subscriptions = [...data];
  const extIndex = subscriptions.findIndex(
    (sub) => sub.deviceId === subscription.deviceId,
  );

  if (extIndex === -1) {
    if (subscription) {
      subscriptions.push(subscription);
      return subscriptions;
    }
  }
  if (subscription.subscription) {
    subscriptions[extIndex] = subscription;
  } else {
    subscriptions.splice(extIndex);
  }

  return subscriptions;
};

// export const createConversationId = (userId, botId) => {
//   const ids = [userId, botId];
//   ids.sort();
//   const text = ids.join('-');
//   return `${userId.substr(0, 10)}-${sha1(text).substr(0, 12)}`;
// };

export const getStripeAmount = (amount) => (Math.round(amount * 100) / 100) * 100;

export const ORIENTATION = {
  PORTRAIT: 'portrait',
  LANDSCAPE: 'landscape',
};

export const isMobileDevice = () => {
  const { orientation } = window;
  let orientationName = '';

  switch (orientation) {
    case 0:
    case 180:
      orientationName = ORIENTATION.PORTRAIT;
      break;
    case 90:
    case 270:
      orientationName = ORIENTATION.LANDSCAPE;
      break;
    default:
      orientationName = ORIENTATION.PORTRAIT;
  }

  if (orientationName === ORIENTATION.PORTRAIT && window.innerHeight < 1000 && window.innerWidth < 600) {
    return {
      isMobile: true,
      orientation: ORIENTATION.PORTRAIT,
    };
  }
  if (orientationName === ORIENTATION.LANDSCAPE && window.innerHeight < 600 && window.innerWidth < 1000) {
    return {
      isMobile: true,
      orientation: ORIENTATION.LANDSCAPE,
    };
  }

  return { isMobile: false };
};

export const isIpad = () => {
  const isiPad = navigator.userAgent.match(/iPad/i) !== null;
  // let isEdge = false;
  // if (window.navigator.userAgent.indexOf('Edge') > -1) {
  //   isEdge = true;
  // }

  if (isiPad) {
    return true;
  }
  return false;
};

export const getNameAcronym = (name) => {
  if (name.length === 0) {
    return '';
  }

  const matches = name.match(/\b(\w)/g); // ['J','S','O','N']

  let acronym = matches.join(''); // JSON
  acronym = matches.length > 1 ? R.take(2, matches) : matches;
  acronym = acronym.join('');

  return acronym;
};

export const validURL = (str) => {
  // const pattern = new RegExp(
  //   '^(http(s)?:\\/\\/)?' // protocol
  //     + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name
  //     + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
  //     + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
  //     + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
  //     + '(\\#[-a-z\\d_]*)?$',
  //   'i',
  // ); // fragment locator
  // return !!pattern.test(str);

  // change the URL checking function by using new URL()
  try {
    if (typeof new URL(str) === 'object') {
      return true;
    }
  } catch (err) {
    return false;
  }
  return null;
};

// Helper to dynamically loading manifest.json default to frontM manifest.json
export const updateManifestFile = (manifestFileUrl = './manifest.json') => {
  document.getElementById('manifest-details').remove();
  const link = document.createElement('link');
  link.id = 'manifest-details';
  link.rel = 'manifest';
  link.href = manifestFileUrl;
  document.head.appendChild(link);

  let favicon = document.querySelector('link[rel~=\'icon\']');
  if (!favicon) {
    favicon = document.createElement('link');
    favicon.rel = 'icon';
    document.head.appendChild(favicon);
  }

  if (manifestFileUrl === './seamplify-manifest.json') {
    favicon.href = `${window.location.origin}/img/seamplify-favicon.ico`;
  } else if (manifestFileUrl === './thuraya-sattrack-manifest.json') {
    favicon.href = `${window.location.origin}/img/Thuraya-Sattrack-Domain.ico`;
  } else if (manifestFileUrl === './oneCare-manifest.json') {
    favicon.href = `${window.location.origin}/img/newOneCare.ico`;
  } else if (manifestFileUrl === './stationSatcom-manifest.json') {
    favicon.href = `${window.location.origin}/img/satComFav.ico`;
  } else if (manifestFileUrl === './pulsar-manifest.json') {
    favicon.href = `${window.location.origin}/img/pulsar-favicon.ico`;
  } else if (manifestFileUrl === './intelsat-manifest.json') {
    favicon.href = `${window.location.origin}/img/intelsat.ico`;
  } else {
    favicon.href = `${window.location.origin}/favicon.png`;
  }
};

export const chatDayFormats = {
  sameDay: '[Today]',
  nextDay: '[Tomorrow]',
  nextWeek: 'dddd',
  lastDay: '[Yesterday]',
  lastWeek: '[Last] dddd',
  sameElse: 'DD/MM/YYYY',
};

export const isNormalMessage = (type) => (
  type === MessageTypeConstants.MESSAGE_TYPE_STRING
  || type === MessageTypeConstants.MESSAGE_TYPE_CARD_RESPONSE
  || type === MessageTypeConstants.MESSAGE_TYPE_WAIT
  || type === MessageTypeConstants.MESSAGE_TYPE_BUTTON_RESPONSE
  || type === MessageTypeConstants.MESSAGE_TYPE_CONTACT_CARD
  || type === MessageTypeConstants.MESSAGE_TYPE_CHAT
);

export const isNotificationMessage = (type) => (
  type === MessageTypeConstants.MESSAGE_TYPE_STD_NOTIFICATION
  || type === MessageTypeConstants.MESSAGE_TYPE_CRITICAL_NOTIFICATION
  || type === MessageTypeConstants.MESSAGE_TYPE_AUTHORIZATION_REQUEST
);

export const parseFavourites = (response, botSubscriptions) => {
  // in response we get one array of favourites with contacts + channels + bots. We split there here accordingly.
  const botFavList = [], contactFavList = [], channelFavList = [];

  response?.favourites?.map(item => {
    if (botSubscriptions.some(bot => bot.botId === item.bot.botId)) {
      botFavList.push(item);
    }
    if (item.contact !== null) {
      contactFavList.push(item);
    }
    if (item?.channel !== null) {
      channelFavList.push(item);
    }
  });
  // below filter just removes duplicates from the array
  return [...botFavList, ...contactFavList, ...channelFavList].filter((v, i, a) => a.findIndex((t) => t.conversationId === v.conversationId) === i);
};

export const getOriginConfig = () => {
  const landingPath = getSignupPath();

  switch (landingPath) {
    case STATION_ONE_LANDING:
      return 'StationOne';
    default:
      return 'FrontM';
  }
};

export const getDarkenHexColor = (hex, amount = 20) => {
  if (!hex || typeof hex !== "string") return hex;

  // Normalize short hex like #fff
  if (hex.length === 4) {
    hex = "#" + hex.slice(1).split("").map(c => c + c).join("");
  }

  // Convert hex to RGB
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);

  // Convert to HSL
  r /= 255;
  g /= 255;
  b /= 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // achromatic
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d) + (g < b ? 6 : 0); break;
      case g: h = ((b - r) / d) + 2; break;
      case b: h = ((r - g) / d) + 4; break;
    }
    h /= 6;
  }

  s = Math.min(1, s * 1.2);       // boost saturation
  l = Math.max(0, l - amount / 100);  // darken

  // Convert back to RGB
  const hue2rgb = (p, q, t) => {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  };

  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;

  const rNew = Math.round(hue2rgb(p, q, h + 1 / 3) * 255);
  const gNew = Math.round(hue2rgb(p, q, h) * 255);
  const bNew = Math.round(hue2rgb(p, q, h - 1 / 3) * 255);

  const toHex = v => v.toString(16).padStart(2, '0');
  return `#${toHex(rNew)}${toHex(gNew)}${toHex(bNew)}`;
};

/** Merge new + existing messages, remove duplicates, and sort by createdOn ASC */
export const mergeAndSortMessages = (newMsgs, existingMsgs = []) => {
  const seen = new Set();
  const merged = [...newMsgs, ...existingMsgs].filter((m) => {
    if (!m?.messageId || seen.has(m.messageId)) return false;
    seen.add(m.messageId);
    return true;
  });
  return merged.sort(
    (a, b) => new Date(a.createdOn).getTime() - new Date(b.createdOn).getTime()
  );
}

/** Update pagination info for this conversation */
export const updatePagination = (map, conversationId, messages, moreMessagesExist) => {
  const firstCreatedOn =
    messages.length > 0 ? messages[messages.length - 1].createdOn : "";
  return {
    ...map,
    [conversationId]: {
      hasMoreMessages: Boolean(moreMessagesExist),
      createdOn: firstCreatedOn,
    },
  };
}